"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSignature = exports.KeySignature = exports.TransactionResult = exports.Signer = exports.AnchorBody = exports.AllowedTransactions = exports.Fee = exports.ANCHORS_URL = exports.DN_URL = exports.ACME_TOKEN_URL = void 0;
__exportStar(require("./enums_gen"), exports);
__exportStar(require("./types_gen"), exports);
__exportStar(require("./unions_gen"), exports);
const buffer_1 = require("../common/buffer");
const types_gen_1 = require("./types_gen");
types_gen_1.AccumulateDataEntry.prototype.hash = function () {
    if (!this.data) {
        return new Uint8Array();
    }
    return (0, common_1.hashTree)(this.data.map((v) => v || new Uint8Array()));
};
types_gen_1.DoubleHashDataEntry.prototype.hash = function () {
    if (!this.data) {
        return new Uint8Array();
    }
    return (0, common_1.sha256)((0, common_1.hashTree)(this.data.map((v) => v || new Uint8Array())));
};
types_gen_1.FactomDataEntryWrapper.prototype.asBinary = function () {
    const len2buf = (x) => new Uint8Array([x >> 8, x]);
    const extIds = buffer_1.Buffer.concat((this.extIds || []).map((x) => {
        return buffer_1.Buffer.concat([len2buf(x?.length || 0), x || new Uint8Array()]);
    }));
    return buffer_1.Buffer.concat([
        buffer_1.Buffer.from([0]),
        buffer_1.Buffer.from(this.accountId || new Uint8Array(32)),
        len2buf(extIds.length),
        extIds,
        this.data || new Uint8Array(),
    ]);
};
types_gen_1.FactomDataEntryWrapper.prototype.hash = function () {
    const data = this.asBinary();
    const sum = (0, common_1.sha512)(data);
    const salted = buffer_1.Buffer.concat([sum, data]);
    return (0, common_1.sha256)(salted);
};
/* eslint-disable @typescript-eslint/no-namespace */
const _1 = require(".");
const url_1 = require("../address/url");
const common_1 = require("../common");
const unions_gen_1 = require("./unions_gen");
/**
 * The URL of the ACME token
 */
exports.ACME_TOKEN_URL = url_1.AccumulateURL.parse("acc://ACME");
/**
 * The URL of the DN
 */
exports.DN_URL = url_1.AccumulateURL.parse("acc://dn.acme");
/**
 * The URL of the anchors
 */
exports.ANCHORS_URL = exports.DN_URL.join("anchors");
/** @ignore */
var Fee;
(function (Fee) {
    function getName(fee) {
        return fee;
    }
    Fee.getName = getName;
    function fromObject(obj) {
        if (typeof obj === "string")
            return Number(obj);
        return obj;
    }
    Fee.fromObject = fromObject;
})(Fee = exports.Fee || (exports.Fee = {}));
/** @ignore */
var AllowedTransactions;
(function (AllowedTransactions) {
    function fromObject(obj) {
        if (!obj.length)
            return [];
        if (typeof obj[0] === "number")
            return obj;
        return obj.map((v) => _1.TransactionType.byName(v));
    }
    AllowedTransactions.fromObject = fromObject;
})(AllowedTransactions = exports.AllowedTransactions || (exports.AllowedTransactions = {}));
/** @ignore */
var AnchorBody;
(function (AnchorBody) {
    function fromObject(obj) {
        return _1.TransactionBody.fromObject(obj);
    }
    AnchorBody.fromObject = fromObject;
})(AnchorBody = exports.AnchorBody || (exports.AnchorBody = {}));
/** @ignore */
var Signer;
(function (Signer) {
    function fromObject(obj) {
        return _1.Account.fromObject(obj);
    }
    Signer.fromObject = fromObject;
})(Signer = exports.Signer || (exports.Signer = {}));
/** @ignore */
var TransactionResult;
(function (TransactionResult) {
    function fromObject(obj) {
        if (obj instanceof _1.AddCreditsResult)
            return obj;
        if (obj instanceof _1.EmptyResult)
            return obj;
        if (obj instanceof _1.WriteDataResult)
            return obj;
        switch (obj.type) {
            case (_1.TransactionType.AddCredits, "addCredits"):
                return new _1.AddCreditsResult(obj);
            case (_1.TransactionType.Unknown, "unknown"):
                return new _1.EmptyResult(obj);
            case (_1.TransactionType.WriteData, "writeData"):
                return new _1.WriteDataResult(obj);
        }
        throw new Error(`Unknown signature '${obj.type}'`);
    }
    TransactionResult.fromObject = fromObject;
})(TransactionResult = exports.TransactionResult || (exports.TransactionResult = {}));
/** @ignore */
var KeySignature;
(function (KeySignature) {
    function fromObject(obj) {
        return unions_gen_1.Signature.fromObject(obj);
    }
    KeySignature.fromObject = fromObject;
})(KeySignature = exports.KeySignature || (exports.KeySignature = {}));
/** @ignore */
var UserSignature;
(function (UserSignature) {
    function fromObject(obj) {
        return unions_gen_1.Signature.fromObject(obj);
    }
    UserSignature.fromObject = fromObject;
})(UserSignature = exports.UserSignature || (exports.UserSignature = {}));
//# sourceMappingURL=index.js.map